<template>
  <div>
    <DealCandidateSummary
      :firstName="firstName"
      :lastName="lastName"
      :emailAddress="emailAddress"
    />
    <ExpensesSummary
      v-if="showExpensesSection"
      :expenses="expenses"
    />
    <SummaryTitle title="Contractor"/>
    <SummaryItem itemTitle="Job Title">
      <template v-slot:content>
        {{ jobTitle ? jobTitle : 'Missing' }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Consultant Type">
      <template v-slot:content>
        {{ employeeType }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Contract Type">
      <template v-slot:content>
        {{ contractType }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Contract Length" v-if="isContractToHire">
      <template v-slot:content>
        {{ lengthOfContractLabel }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Conversion Fee" v-if="isContractToHire">
      <template v-slot:content>
        {{ conversionFeeLabel }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Start Date">
      <template v-slot:content>
        {{ startAtLabel }}
      </template>
    </SummaryItem>
    <SummaryItem v-if="showEndDate" item-title="End Date">
      <template v-slot:content>
        {{ endAtLabel }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Pay Frequency">
      <template v-slot:content>
        {{ payFrequencyLabel }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Pay Rate">
      <template v-slot:content>
        {{ payRateLabel }} {{ payRateTypeLabel }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Bill Rate">
      <template v-slot:content>
        {{ billRateLabel }} {{ billRateTypeLabel }}
      </template>
    </SummaryItem>
    <CommissionsSummary
      v-if="showCommissionsSection"
      :commissions="commissions"
    >
    </CommissionsSummary>
  </div>
</template>
<script>
import { SummaryItem, SummaryTitle, ExpensesSummary, CommissionsSummary } from '@/components/shared/display'
import DealCandidateSummary from './DealCandidateSummary.vue'
import getEmployeeTypeLabel from '@/lib/display/getEmployeeTypeLabel'
import getContractTypeLabel from '@/lib/display/getContractTypeLabel'
import formatCurrency from '@/lib/display/formatCurrency'
import formatDate from '@/lib/display/formatDate'
import getPayFrequencyLabel from '@/lib/display/getPayFrequencyLabel'
import getPayRateTypeLabel from '@/lib/display/getPayRateTypeLabel'
import getBillRateTypeLabel from '@/lib/display/getBillRateTypeLabel'
import { CONTRACT_TO_HIRE } from '@/lib/constants/contractTypes'

export default {
  components: {
    SummaryTitle,
    SummaryItem,
    ExpensesSummary,
    CommissionsSummary,
    DealCandidateSummary
  },
  props: [
    'firstName',
    'lastName',
    'emailAddress',
    'jobTitle',
    'employeeTypeId',
    'contractTypeId',
    'lengthOfContract',
    'conversionFee',
    'startAt',
    'endAt',
    'payFrequencyId',
    'payRate',
    'payRateTypeId',
    'billRate',
    'billRateTypeId',
    'commissions',
    'expenses'
  ],
  data () {
    return {
      CONTRACT_TO_HIRE
    }
  },
  computed: {
    employeeType () {
      return this.employeeTypeId ? getEmployeeTypeLabel(this.employeeTypeId) : 'Missing'
    },
    contractType () {
      return this.contractTypeId ? getContractTypeLabel(this.contractTypeId) : 'Missing'
    },
    lengthOfContractLabel () {
      return this.lengthOfContract ? this.lengthOfContract + ' months' : 'Missing'
    },
    isContractToHire () {
      return this.isContractor && this.deal.contractTypeId === this.$constants.CONTRACT_TYPES.CONTRACT_TO_HIRE
    },
    conversionFeeLabel () {
      return this.conversionFee ? formatCurrency(this.conversionFee) : 'Missing'
    },
    startAtLabel () {
      return this.startAt ? formatDate(this.startAt) : 'Missing'
    },
    endAtLabel () {
      return this.endAt ? formatDate(this.endAt) : 'Missing'
    },
    showEndDate () {
      return !!this.contractTypeId &&
        this.contractTypeId === this.CONTRACT_TO_HIRE
    },
    payFrequencyLabel () {
      return this.payFrequencyId ? getPayFrequencyLabel(this.payFrequencyId) : 'Missing'
    },
    payRateLabel () {
      return this.payRate ? formatCurrency(this.payRate) : 'Missing Rate'
    },
    payRateTypeLabel () {
      return this.payRateTypeId ? getPayRateTypeLabel(this.payRateTypeId) : 'Missing Type'
    },
    billRateLabel () {
      return this.billRate ? formatCurrency(this.billRate) : 'Missing Rate'
    },
    billRateTypeLabel () {
      return this.billRateTypeId ? getBillRateTypeLabel(this.billRateTypeId) : 'Missing Type'
    },
    showCommissionsSection () {
      return this.commissions && this.commissions.length > 0
    },
    showExpensesSection () {
      return this.expenses && this.expenses.length > 0
    }
  }
}
</script>
